module.exports = __webpack_public_path__ + "img/hb_img01.b57e99cd.png";